import { useMemo } from "react";
import { useSelector } from "react-redux";
import { CarPostBookingSelectors } from "@apac/components/cars";
import { type Reservation, ReservationStateEnum } from "@b2bportal/ground-api";

export const useCarTripStatus = (reservation: Reservation) => {
  const carItineraries = useSelector(
    CarPostBookingSelectors.getAllCarReservations
  );

  const reservationState = reservation?.state?.ReservationState;

  const isCanceled = reservationState === ReservationStateEnum.Cancelled;

  const isPast = useMemo(() => {
    const pastCarReservations = carItineraries?.["Past"] ?? [];

    return (
      pastCarReservations.find(
        (item) => item.reservationId === reservation?.internalGroundBookingId
      ) != null
    );
  }, [carItineraries, reservation]);

  const isActive =
    reservationState !== ReservationStateEnum.Cancelled && !isPast;

  const isCompleted =
    isPast &&
    reservationState !== ReservationStateEnum.Cancelled &&
    reservationState !== ReservationStateEnum.Failure;

  return {
    state: reservationState,
    isPast,
    isCanceled,
    isCompleted,
    isPastOrCanceled: isPast || isCanceled,
    isActive,
  };
};
